import React from 'react'
import HandsImg from "../../assets/gigahands.gif";
import UniTacImg from "../../assets/UniTac.gif";
import Deform360Img from "../../assets/deform360.gif";

const Info = () => {
    return (
        <div className="research__info grid">
            <div className="research__box">
                <div className="research__teaser">
                    <img src={Deform360Img} alt="" className="research__img" />
                </div>
                <div className="research__paragraph">
                    <div className="research__topic">
                        <p className="research__title"> Deform360: A Massive Multi-view Visuotactile Dataset for Deformable World Models</p>
                    </div>
                    <div>
                        <span className="research__subheading">
                            <a href="https://lhy.xyz/"> Hongyu Li*</a>,
                            <strong>Wanjia Fu*</strong>,
                            <a href="https://oliver-cong02.github.io/"> Xiaoyan Cong</a>,
                            <a href="https://kunkun0w0.github.io/"> Zekun Li </a>,
                            <a href="https://binghao-huang.github.io/"> Binghao Huang</a>,
                            <a href="https://jianghanxiao.github.io/"> Hanxiao Jiang</a>,
                            Xintong He,
                            <a href="https://lynl7130.github.io/"> Yiqing Liang</a>,
                            <a href="https://freddierao.github.io/"> Rao Fu</a>,
                            <a href="https://inspirelt.github.io/"> Tao Lu</a>,
                            <a href="https://cs.brown.edu/people/ssrinath/"> Srinath Sridhar</a>,
                            <a href="https://www.mit.edu/~k2smith/">Kevin A. Smith</a>,
                            <a href="https://cs.brown.edu/people/gdk/"> George Konidaris</a>,
                            <a href="https://yunzhuli.github.io/"> Yunzhu Li </a>
                        </span>
                    </div>
                    <div className="research__subtitle">
                        <p><i> European Conference on Computer Vision (ECCV), 2026</i></p>
                    </div>
                    
                    
                    <div className="research__links">
                        <a href="https://arxiv.org/abs/2607.05390"class="btn btn-sm z-depth-0" role="button" target="_blank" rel="noreferrer">arXiv</a>
                        <a href="https://deform360.lhy.xyz/"class="btn btn-sm z-depth-0" role="button" target="_blank" rel="noreferrer">HTML</a>
                        <a href="https://huggingface.co/datasets/brownu/deform360"class="btn btn-sm z-depth-0" role="button" target="_blank" rel="noreferrer">Dataset</a>
                        <a href="https://github.com/lhy0807/deform360"class="btn btn-sm z-depth-0" role="button" target="_blank" rel="noreferrer">Code</a>
                    </div>

                </div>
            </div> 
            <div className="research__box">
                <div className="research__teaser">
                    <img src={UniTacImg} alt="" className="research__img" />
                </div>
                <div className="research__paragraph">
                    <div className="research__topic">
                        <p className="research__title"> UniTac: Whole-Robot Touch Sensing Without Tactile Sensors</p>
                        {/* <div className="research__social">
                            <a href="https://arxiv.org/abs/2507.07980" 
                            className="research__social-icon" rel="noreferrer" target="_blank">
                            <i class="uil uil-file-alt"></i>
                            </a>
                        </div> */}
                    </div>
                    <div>
                        <span className="research__subheading">
                            <strong>Wanjia Fu*</strong>,
                            <a href="https://lhy.xyz/"> Hongyu Li*</a>,
                            <a href="https://ivyyyy24381.github.io/home"> Ivy X. He</a>,
                            <a href="https://cs.brown.edu/people/stellex/"> Stefanie Tellex</a>,
                            <a href="https://cs.brown.edu/people/ssrinath/"> Srinath Sridhar</a>
                        </span>
                    </div>
                    <div className="research__subtitle">
                        <p><i>IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR) Workshop, 2026</i></p>
                        <p><i style={{ color: 'red' }}>Outstanding Paper Award </i>at CVPR 2026 <a href="https://sense-of-space.github.io/">Sense of Space (SOS)</a> workshop.</p>
                    </div>
                    
                    
                    <div className="research__links">
                        <a href="https://arxiv.org/abs/2507.07980"class="btn btn-sm z-depth-0" role="button" target="_blank" rel="noreferrer">arXiv</a>
                        <a href="https://ivl.cs.brown.edu/research/unitac"class="btn btn-sm z-depth-0" role="button" target="_blank" rel="noreferrer">HTML</a>
                        <a href="https://github.com/julia-fu0528/UniTac"class="btn btn-sm z-depth-0" role="button" target="_blank" rel="noreferrer">Code</a>
                    </div>

                </div>
            </div> 
            <div className="research__box">
                <div className="research__teaser">
                    <img src={HandsImg} alt="" className="research__img" />
                </div>
                <div className="research__paragraph">
                    <div className="research__topic">
                        <p className="research__title"> GigaHands: A Massive Annotated Dataset of Bimanual Hand Activities </p>
                        {/* <div className="research__social">
                            <a href="https://www.arxiv.org/pdf/2412.04244" 
                            className="research__social-icon" rel="noreferrer" target="_blank">
                            <i class="uil uil-file-alt"></i>
                            </a>
                        </div> */}
                    </div>
                    <div>
                        <span className="research__subheading">
                            <a href="https://freddierao.github.io/">Rao Fu*</a>,
                            <a href="https://kristen-z.github.io/"> Dingxi Zhang*</a>
                            <a href="https://www.alex-jiang.com/about/"> Alex Jiang</a>,
                            <strong> Wanjia Fu</strong>,
                            <a href="https://austin-funk.github.io/"> Austin Funk</a>,
                            <a href="https://dritchie.github.io/"> Daniel Ritchie</a>,
                            <a href="https://cs.brown.edu/people/ssrinath/"> Srinath Sridhar</a>
                        </span>
                    </div>
                    <div className="research__subtitle">
                    <p><i>IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR), 2025</i></p>
                    <p><i><strong>Highlight Paper</strong></i></p>
                    </div>
 
                    <div className="research__links">
                        <a href="https://www.arxiv.org/abs/2412.04244"class="btn btn-sm z-depth-0" role="button" target="_blank" rel="noreferrer">arXiv</a>
                        <a href="https://ivl.cs.brown.edu/research/gigahands.html"class="btn btn-sm z-depth-0" role="button" target="_blank" rel="noreferrer">HTML</a>
                        <a href="https://github.com/Kristen-Z/GigaHands"class="btn btn-sm z-depth-0" role="button" target="_blank" rel="noreferrer">Dataset</a>
                        <a href="https://github.com/Kristen-Z/GigaHands" class="btn btn-sm z-depth-0" role="button" target="_blank" rel="noreferrer">Code</a>
                    </div>
                </div>
            </div> 
            
        </div>
    )
}

export default Info